export const DOMAIN = 'auth.customer.users';
